import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Wrapper = styled.div`
  position: relative;
  > img {
    max-width: 100%;
    height: auto;
  }

  .react-multi-carousel-list {
    min-height: ${({ height }) => height + 'px'};
    background-color: #e9e8ec;
  }

  .react-multi-carousel-item {
    height: ${({ height }) => height + 'px'};
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: relative;
    }
  }

  .react-multiple-carousel__arrow {
    top: 0;
    width: 22%;
    height: 100%;
    border-radius: 0;
    padding: 0;
    opacity: 0;
    visibility: hidden;
    z-index: 1;

    &::before {
      font-weight: 700;
    }
  }

  .react-multiple-carousel__arrow--left {
    left: 0;
    background: linear-gradient(
      to left,
      transparent 0%,
      rgba(0, 0, 0, 0.25) 100%
    );
    &:hover {
      background: linear-gradient(
        to left,
        transparent 0%,
        rgba(0, 0, 0, 0.25) 100%
      );
    }
  }

  .react-multiple-carousel__arrow--right {
    right: 0;
    background: linear-gradient(
      to right,
      transparent 0%,
      rgba(0, 0, 0, 0.25) 100%
    );
    &:hover {
      background: linear-gradient(
        to right,
        transparent 0%,
        rgba(0, 0, 0, 0.25) 100%
      );
    }
  }

  .react-multi-carousel-dot-list {
    position: absolute;
    bottom: -30%;
    left: 0;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(
      to bottom,
      transparent 0%,
      rgba(0, 0, 0, 0.25) 100%
    );
    transition: bottom 0.3s ease;
  }

  .react-multi-carousel-dot {
    align-items: center;

    button {
      width: 6px;
      height: 6px;
      border: 0;
      background-color: ${themeGet('color.3', '#E9E8E8')};
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
    }
  }

  .react-multi-carousel-dot--active {
    button {
      width: 8px;
      height: 8px;
      background-color: ${themeGet('color.1', '#ffffff')};
    }
  }

  &:hover {
    .react-multiple-carousel__arrow {
      opacity: 1;
      visibility: visible;
    }

    .react-multi-carousel-dot-list {
      bottom: 0;
    }
  }

  &.mobile {
    .react-multiple-carousel__arrow {
      opacity: 1;
      visibility: visible;
      width: 25px;
      min-width: 25px;
      &:before {
        background-color: ${themeGet('color.1', '#ffffff')};
        color: ${themeGet('primary.0', '#194AB9')};
        line-height: 36px;
        font-size: 15px;
      }
      &.react-multiple-carousel__arrow--right {
        &:before {
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
        }
      }
      &.react-multiple-carousel__arrow--left {
        &:before {
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;
        }
      }
    }
  }
`;

export const PlaceholderWrapper = styled.div`
  height: ${({ height }) => height + 'px'};
  border-width: 1px;
  border-style: solid;
  border-bottom-width: 0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-color: ${themeGet('border.3', '#E6E6E6')};
  transition: border-color 0.2s ease;
`;

export const NumberWrapper = styled.div`
  position: absolute;
  bottom: 3px;
  left: 15px;
  display: flex;
  align-items: center;
  padding: 5px;
`;

export const Number = styled.p`
  margin-bottom: 0;
  color: ${themeGet('color.1', '#ffffff')};
  margin-left: 4px;
  font-weight: bold;
`;
